import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const SubSubSectionHeader = styled('h3')`
  ${({ theme }) => theme.typography.baseStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
  margin: 0 0 ${({ theme }) => theme.x1spacePx}px;

  ${media.lgUp`
    color: ${(props) => props.theme.color.white};
  `}
`;
